//import { useLangsStore } from "~~/base/app/stores/langs"
//import { useDataStore } from "~~/base/app/stores/data"

import { useCollection, useFirestore } from "vuefire"
import { writeBatch, doc, setDoc, collection } from "firebase/firestore"

import type { tsAppendableObj } from "~~/base/app/types"

export const useDexStore = defineStore("dex", () => {
	const db = useFirestore()
	// const LangsStore = useLangsStore()
	// const DataStore = useDataStore()

	const prefix = "__"
	const context = ref(<tsAppendableObj>{
		filters: {
			dates: { start: null, end: null },
			company_main_uid: "all",
			interval: "psi1",
			user_name: "",
			only_with_routes: true,
			is_active_only: true,
		},
		import_details: false,
		import_status: "",
		is_loading: false,
		whats: [
			{ what: "messages", prefix: prefix, type: "app", context: "DEX" },
			{ what: "main_langs", prefix: prefix, type: "app", context: "DEX" },
		],
	})

	return {
		context,
	}
})

// const samples = ref([
// 	{
// 		uid: 'dronvers',
// 		mainColor: '0063db',
// 		secondaryColor: '000000',
// 		bgColor: 'ffffff',
// 		data: 'https://dronvers.com',
// 		image: '/DronversIcon.svg',
// 	},
// 	{
// 		uid: 'dexterial',
// 		mainColor: 'ffffff',
// 		secondaryColor: 'cccccc',
// 		bgColor: '000000',
// 		data: 'https://dexterial.com',
// 		image: 'https://dexterial.com/logo_mic.png',
// 	},

// 	{
// 		uid: 'olioliweb',
// 		mainColor: 'c771ba',
// 		secondaryColor: '164468',
// 		bgColor: 'ffffff',
// 		data: 'https://olioliwebdesign.ro',
// 		image:
// 			'https://olioliwebdesign.ro/files/dynamicContent/sites/hlbj8u/images/en/webpage_32/m7p2u1hf/element_1555/Adauga-un-antet-500-x-500-px_20241017_161012_0000.png',
// 	},
// ])
